import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import invariant from '../utils/invariant';
/**
 * @const
 * @type {RegExp}
 */

var REG_DUPLICATE_SLASH = /\/{2,}/;
/**
 * @const
 * @type {RegExp}
 */

var REG_DUPLICATE_SLASH_REPLACE = new RegExp(REG_DUPLICATE_SLASH, 'g');
/**
 * @const
 * @type {RegExp}
 */

var REG_TRAILING_SLASH = /\/+$/;
/**
 * @const
 * @type {Object<string, string>}
 */

var Method = {
  GET: 'get',
  POST: 'post',
  DELETE: 'delete',
  PUT: 'put',
  PATCH: 'patch',
  HEAD: 'head',
  CONNECT: 'connect',
  OPTIONS: 'options',
  TRACE: 'trace'
  /**
   * @param {object} res
   * @returns {Promise}
   */

};
export function defaultOnResponseResolve(res) {
  return Promise.resolve(res.data);
}
/**
 * @param {Error} err
 * @returns {Promise<Error>}
 */

export function defaultOnResponseReject(err) {
  Object.assign(err, {
    isApiError: true
  });
  return Promise.reject(err);
}

var Restful =
/*#__PURE__*/
function () {
  _createClass(Restful, null, [{
    key: "service",

    /**
     * @static
     * @param {?object} options
     * @returns {Restful}
     */
    value: function service(options) {
      return new Restful(options);
    }
    /**
     * @static
     * @param {Restful} restful
     * @returns {Restful}
     */

  }, {
    key: "clone",
    value: function clone(restful) {
      invariant(restful instanceof Restful, 'restful expected a instance of Restful, instead received %s.', restful);
      return restful.clone();
    }
    /**
     * @constructor
     * @param {?object} options
     * @returns {Restful}
     */

  }]);

  function Restful() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Restful);

    var client = options.client,
        _options$entry = options.entry,
        entry = _options$entry === void 0 ? '/' : _options$entry,
        _options$trailingSlas = options.trailingSlash,
        trailingSlash = _options$trailingSlas === void 0 ? false : _options$trailingSlas,
        _options$onResponseRe = options.onResponseResolve,
        onResponseResolve = _options$onResponseRe === void 0 ? defaultOnResponseResolve : _options$onResponseRe,
        _options$onResponseRe2 = options.onResponseReject,
        onResponseReject = _options$onResponseRe2 === void 0 ? defaultOnResponseReject : _options$onResponseRe2;
    invariant(client && typeof client.request === 'function', 'options.client expected a object that has a request function, instead received %s.', client);
    invariant(typeof entry === 'number' || typeof entry === 'string', 'options.entry expected a number or a string, instead, received %s.', entry);
    invariant(typeof onResponseResolve === 'function', 'options.onResponseResolve expected a function, instead received %s.', onResponseResolve);
    invariant(typeof onResponseReject === 'function', 'options.onResponseReject expected a function, instead received %s.', onResponseReject);
    this._client = client;
    this._entry = entry;
    this._trailingSlash = trailingSlash;
    this._onResponseResolve = onResponseResolve;
    this._onResponseReject = onResponseReject;
  }
  /**
   * @public
   * @returns {boolean}
   */


  _createClass(Restful, [{
    key: "service",

    /**
     * @public
     * @param {number|string} entry
     * @returns {Restful}
     */
    value: function service(entry) {
      return new Restful({
        client: this._client,
        trailingSlash: this._trailingSlash,
        entry: entry
      });
    }
    /**
     * @public
     * @returns {Restful}
     */

  }, {
    key: "clone",
    value: function clone() {
      return new Restful({
        client: this._client,
        trailingSlash: this._trailingSlash,
        entry: this._entry
      });
    }
    /**
     * @public
     * @param {number|string} path
     * @returns {Restful}
     */

  }, {
    key: "custom",
    value: function custom(path) {
      invariant(typeof path === 'number' || typeof path === 'string', 'path expected a number or a string, instead received %s.', path);
      var entry = "".concat(this._entry, "/").concat(path);
      return this.service(entry);
    }
    /**
     * @public
     * @param {number|string} route
     * @returns {Restful}
     */

  }, {
    key: "all",
    value: function all(route) {
      return this.custom(route);
    }
    /**
     * @public
     * @param {number|string} route
     * @param {number|string} id
     * @returns {Restful}
     */

  }, {
    key: "one",
    value: function one(route, id) {
      invariant(typeof route === 'number' || typeof route === 'string', 'route expected a number or a string, instead received %s.', route);
      invariant(id === undefined || typeof id === 'number' || typeof id === 'string', 'id expected a number or a string, instead received %s.', id);
      var path = id === undefined ? route : "".concat(route, "/").concat(id);
      return this.custom(path);
    }
    /**
     * @public
     * @param {?object} options
     * @returns {Promise}
     */

  }, {
    key: "request",
    value: function request(options) {
      var _this = this;

      return new Promise(function (resolve) {
        resolve(_this._client.request(_this.entry, options));
      }).then(this._onResponseResolve, this._onResponseReject);
    }
    /**
     * @public
     * @param {?object} options
     * @returns {Promise}
     */

  }, {
    key: "get",
    value: function get(options) {
      return this.request(_objectSpread({}, options, {
        method: Method.GET
      }));
    }
    /**
     * @public
     * @param {?object} data
     * @param {?object} options
     * @returns {Promise}
     */

  }, {
    key: "post",
    value: function post(data, options) {
      return this.request(_objectSpread({}, options, {
        method: Method.POST,
        data: data
      }));
    }
    /**
     * @public
     * @param {?object} options
     * @returns {Promise}
     */

  }, {
    key: "delete",
    value: function _delete(options) {
      return this.request(_objectSpread({}, options, {
        method: Method.DELETE
      }));
    }
    /**
     * @public
     * @param {?object} data
     * @param {?object} options
     * @returns {Promise}
     */

  }, {
    key: "put",
    value: function put(data, options) {
      return this.request(_objectSpread({}, options, {
        method: Method.PUT,
        data: data
      }));
    }
    /**
     * @public
     * @param {?object} data
     * @param {?object} options
     * @returns {Promise}
     */

  }, {
    key: "patch",
    value: function patch(data, options) {
      return this.request(_objectSpread({}, options, {
        method: Method.PATCH,
        data: data
      }));
    }
    /**
     * @public
     * @param {?object} options
     * @returns {Promise}
     */

  }, {
    key: "head",
    value: function head(options) {
      return this.request(_objectSpread({}, options, {
        method: Method.HEAD
      }));
    }
    /**
     * @public
     * @param {?object} options
     * @returns {Promise}
     */

  }, {
    key: "connect",
    value: function connect(options) {
      return this.request(_objectSpread({}, options, {
        method: Method.CONNECT
      }));
    }
    /**
     * @public
     * @param {?object} options
     * @returns {Promise}
     */

  }, {
    key: "options",
    value: function options(_options) {
      return this.request(_objectSpread({}, _options, {
        method: Method.OPTIONS
      }));
    }
    /**
     * @public
     * @param {?object} options
     * @returns {Promise}
     */

  }, {
    key: "trace",
    value: function trace(options) {
      return this.request(_objectSpread({}, options, {
        method: Method.TRACE
      }));
    }
    /**
     * @public
     * @param {?object} options
     * @returns {Promise}
     */

  }, {
    key: "list",
    value: function list(options) {
      return this.get(options);
    }
    /**
     * @public
     * @param {?object} data
     * @param {?object} options
     * @returns {Promise}
     */

  }, {
    key: "create",
    value: function create(data, options) {
      return this.post(data, options);
    }
    /**
     * @public
     * @param {number|string} id
     * @param {?object} options
     * @returns {Promise}
     */

  }, {
    key: "fetch",
    value: function fetch(id, options) {
      return this.one(id).get(options);
    }
    /**
     * @public
     * @param {number|string} id
     * @param {?object} data
     * @param {?object} options
     * @returns {Promise}
     */

  }, {
    key: "update",
    value: function update(id, data, options) {
      return this.one(id).put(data, options);
    }
    /**
     * @public
     * @param {number|string} id
     * @param {?object} options
     * @returns {Promise}
     */

  }, {
    key: "destroy",
    value: function destroy(id, options) {
      return this.one(id).delete(options);
    }
  }, {
    key: "trailingSlash",
    get: function get() {
      return !!this._trailingSlash;
    }
    /**
     * @public
     * @returns {object}
     */

  }, {
    key: "client",
    get: function get() {
      return this._client;
    }
    /**
     * @public
     * @returns {string}
     */

  }, {
    key: "entry",
    get: function get() {
      var _entry = this._entry,
          _trailingSlash = this._trailingSlash;
      var hasTrailingSlash = REG_TRAILING_SLASH.test(_entry);
      var entry;

      if (_trailingSlash && !hasTrailingSlash) {
        entry = "".concat(_entry, "/");
      } else if (!_trailingSlash && hasTrailingSlash) {
        entry = _entry.replace(REG_TRAILING_SLASH, '');
      } else {
        entry = _entry;
      }

      return REG_DUPLICATE_SLASH.test(entry) ? entry.replace(REG_DUPLICATE_SLASH_REPLACE, '/') : entry;
    }
  }]);

  return Restful;
}();

export default Restful;